module.exports = __webpack_public_path__ + "static/carousel-slide-05-968de0e09bcb657b3a4659299ee31ec8.png";